<template>
  <div class="scene-view">
    <div class="fixed-project">> {{ projectCurrentRowData.projectName }}</div>
    <div class="scene-container">
      <el-form class="container" ref="form" :model="form" :show-message="false">
        <el-row :gutter="8">
          <el-col :span="4">
            <div class="box">
              <div class="box-label">场景名称</div>
              <div class="box-container">
                <div class="box-label-container">
                  <p class="group-title">
                    <el-form-item
                      prop="name"
                      :rules="[{
                          type: 'string',
                          required: true,
                          message: '请填写场景名',
                          trigger: 'blur',
                      }]"
                    >
                      <el-input @input="onInput()" size="mini" placeholder="请给您的场景命名" v-model.trim="form.name"/>
                    </el-form-item>
                  </p>
                </div>
                <div class="box-label-container">
                  <p class="group-title">
                    <el-form-item 
                      prop="ruleType"
                      :rules="[
                        {
                          required: true,
                          message: '请选择规则类型',
                          trigger: 'change',
                        },
                      ]">
                      <template v-if="form.id==null">
                        <el-select
                          @input="onInput()"
                          size="mini"
                          placeholder="规则类型"
                          style="width: 50%"
                          v-model="form.ruleType">
                          <el-option
                            v-for="(item, index2) in ruleTypeList"
                            :key="'ruleType' + index2"
                            :label="item.name"
                            :value="item.value"/>
                        </el-select>
                      </template>
                      <template v-else>
                        <el-select
                          @input="onInput()"
                          size="mini"
                          placeholder="规则类型"
                          style="width: 50%"
                          v-model="form.ruleType"
                          disabled>
                          <el-option
                            v-for="(item, index2) in ruleTypeList"
                            :key="'ruleType' + index2"
                            :label="item.name"
                            :value="item.value"/>
                        </el-select>
                      </template>
                    </el-form-item>
                  </p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box">
              <div class="box-label">设定条件</div>
              <div class="box-container" v-if="form.ruleType==10">
                <div class="box-scroll">
                  <div class="box-label-container" v-for="(condition, index1) in conditions" :key="index1">
                    <p class="blankDiv" style="width:8%;">
                      <span v-if="index1 >= 1">{{conditions.length > 1 ? "并且" : ""}}</span>
                    </p>
                    <p class="value" style="width:25%;">
                      <el-form-item :prop="condition.key + '_deviceId'">
                        <el-select
                          @input="onInput()"
                          size="mini"
                          placeholder="请选择设备"
                          style="width: 90%"
                          filterable
                          clearable
                          v-model="form[condition.key + '_deviceId']"
                          @change="changeReadConditionDevice(form[condition.key + '_deviceId'],index1)">
                          <el-option
                            v-for="(item, index2) in deviceList"
                            :key="'fd_device_' + index2 + '_' + item.id"
                            :label="item.productNick"
                            :value="item.id"/>
                        </el-select>
                      </el-form-item>
                    </p>
                    <p class="value" style="width:25%;">
                      <el-form-item :prop="condition.key + '_attr'">
                        <el-select
                          size="mini"
                          placeholder="请选择属性"
                          style="width: 90%"
                          filterable
                          clearable
                          v-model="form[condition.key + '_attr']"
                          @change="changeConditionAttr(form[condition.key + '_attr'],index1)">
                          <el-option
                            v-for="(item, index2) in deviceReadParamList[index1]"
                            :key="condition.key + '_attr_' + index2"
                            :label="item.name"
                            :value="item.id"/>
                        </el-select>
                      </el-form-item>
                    </p>
                    <p class="value" style="width:20%;">
                      <el-form-item :prop="condition.key + '_cmp'">
                        <el-select
                          @input="onInput()"
                          size="mini"
                          placeholder="请选择条件"
                          style="width: 90%"
                          v-model="form[condition.key + '_cmp']">
                          <el-option v-for="(item, index2) in compareList" 
                            :key="condition.key + '_condition' + index2 + '_' + item.value"
                            :label="item.label"
                            :value="item.value"/>
                        </el-select>
                      </el-form-item>
                    </p>
                    <p class="value" style="width:17%;">
                      <el-form-item :prop="condition.key + '_value'">
                        <template v-if="conditionValueList[index1]==null||conditionValueList[index1].length==0">
                          <el-input
                            @input="onInput()"
                            size="mini"
                            placeholder="设定值"
                            style="width: 90%"
                            v-model="form[condition.key + '_value']"/>
                        </template>
                        <template v-if="conditionValueList[index1]!=null&&conditionValueList[index1].length>0">
                          <el-select
                            @input="onInput()"
                            size="mini"
                            placeholder="请选择"
                            style="width: 90%"
                            v-model="form[condition.key + '_value']">
                            <el-option v-for="(item, index2) in conditionValueList[index1]" 
                              :key="condition.key + '_value' + index2 + '_' + item.value"
                              :label="item.label"
                              :value="item.value"/>
                          </el-select>
                        </template>  
                      </el-form-item>
                    </p>
                    <p @click="deleteCondition(index1, condition)" style="width:5%;">
                      &nbsp;&nbsp;<i class="el-icon-delete"></i>
                    </p>
                  </div>
                </div>
                <div class="add-btn" @click="addCondition">+ 添加条件</div>
              </div>
              <div class="box-container" v-if="form.ruleType==20">
                  <el-form-item
                    prop="trigerTime"
                    label="触发时间："
                    :rules="[
                      {
                        required: true,
                        message: '请设定触发时间',
                        trigger: 'change',
                      },
                    ]">
                    <el-input
                      @input="onInput()"
                      size="mini"
                      placeholder="触发时间 08:30"
                      style="width: 20%"
                      v-model="form.trigerTime"/>
                  </el-form-item>
                  <el-form-item
                    prop="weekDays"
                    label="触发日期："
                    :rules="[
                      {
                        required: true,
                        message: '请设定触发日期',
                        trigger: 'change',
                      },
                    ]">
                    <el-input
                      @input="onInput()"
                      size="mini"
                      placeholder="周一到周日 1,2,3,4,5,6,7"
                      style="width: 40%"
                      v-model="form.weekDays"/>
                  </el-form-item>
              </div>
              <div class="box-container" v-if="form.ruleType!=10&&form.ruleType!=20">&nbsp;</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="box">
              <div class="box-label">触发动作</div>
              <div class="box-container">
                <div class="box-scroll">
                  <div class="box-label-container" v-for="(action, index1) in actions" :key="index1">
                    <p class="value" style="width:33%;">
                      <el-form-item :prop="action.key + '_deviceId'">
                        <el-select
                          @input="onInput()"
                          size="mini"
                          placeholder="请选择设备"
                          style="width: 90%"
                          filterable
                          clearable
                          v-model="form[action.key + '_deviceId']"
                          @change="changeWriteConditionDevice(form[action.key+'_deviceId'],index1)">
                          <el-option
                            v-for="(item, index2) in deviceList"
                            :key="action.key + '_device_' + index2 + '_' + item.id"
                            :label="item.productNick"
                            :value="item.id"/>
                        </el-select>
                      </el-form-item>
                    </p>
                    <p class="value" style="width:36%;">
                      <el-form-item :prop="action.key + '_attr'">
                        <el-select
                          @input="onInput()"
                          size="mini"
                          placeholder="请选择状态"
                          style="width: 90%"
                          filterable
                          clearable
                          v-model="form[action.key + '_attr']"
                          @change="changeActionAttr(form[action.key + '_attr'],index1)">
                          <el-option
                            v-for="(item, index2) in deviceWriteParamList[index1]"
                            :key="action.key + '_attr_' + index2 + '_' + item.value"
                            :label="item.name"
                            :value="item.id"/>
                        </el-select>
                      </el-form-item>
                    </p>
                    <p class="value" style="width:24%;">
                      <el-form-item :prop="action.key + '_value'">
                        <template v-if="actionValueList[index1]==null||actionValueList[index1].length==0">
                          <el-input
                            @input="onInput()"
                            size="mini"
                            placeholder="设定值"
                            style="width: 90%"
                            v-model="form[action.key + '_value']"/>
                        </template>
                        <template v-if="actionValueList[index1]!=null&&actionValueList[index1].length>0">
                          <el-select
                            @input="onInput()"
                            size="mini"
                            placeholder="请选择"
                            style="width: 90%"
                            v-model="form[action.key + '_value']">
                            <el-option v-for="(item, index2) in actionValueList[index1]" 
                              :key="action.key + '_value' + index2 + '_' + item.value"
                              :label="item.label"
                              :value="item.value"/>
                          </el-select>
                        </template> 
                      </el-form-item>
                    </p>
                    <p @click="deleteAction(index1, action)" style="width:7%;">
                      &nbsp;&nbsp;<i class="el-icon-delete"></i>
                    </p>
                  </div>
                </div>
                <div class="add-btn" @click="addAction">+ 添加结果</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="exp-title">&nbsp;</div>
      <scene-detail ref="detail" @edit="getDetailInfo" />
      <div class="exp-title">&nbsp;</div>
      <div class="submit-btn">
        <div class="submit-btn-item" @click="submit">保存</div>
        <div class="submit-btn-item" @click="reset">重置</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SceneDetail from "./module/sceneDetail.vue";
import compareList from "./js/compare";
export default {
  name: "ProInfoScene",
  components: {
    SceneDetail
  },
  data() {
    return {
      form: {
        id: null,
        ruleType: null,
        name: null,
        trigerTime: null,
        weekDays: null,
      },
      conditions: [], // 渲染设定条件 html
      actions: [], // 渲染触发动作 html
      compareList,
      deviceList: [], // 设备列表
      deviceParamsList: [], // 根据设备获取设备参数
      deviceReadParamList: [],  // 用户可读参数
      deviceWriteParamList: [], // 用户可读可写参数
      conditionValueList: [], // 触发条件参数值范围
      actionValueList: [],    // 触发动作参数值范围
      ruleTypeList: [
        {
          "name":"动态场景",
          "value":10
        },
        {
          "name":"定时触发",
          "value":20
        }
      ]
    };
  },
  computed: {
    ...mapState(["projectCurrentRowData"]),
  },
  mounted() {
    this.reset();
    this.getDeviceList();
  },
  methods: {
    onInput() {
      this.$forceUpdate();
    },
    getDeviceList() {
      this.request.deviceList({ project: this.projectCurrentRowData.projectCode }).then((res) => {
        this.deviceList = res.data || [];
      });
    },
    getDeviceParams(deviceId, index, flag) {
      this.request.deviceScreenInfo({
        deviceId,
        project: this.projectCurrentRowData.projectCode,
      }).then((res) => {
        this.deviceParamsList = (res.data || {}).dictParams || [];
        if (flag === 1) {
          // readWrite 10：可读，30：可读可写 并且 userFlag 10：用户可查看
          this.deviceReadParamList[index] = this.deviceParamsList.filter(
            (item) => (item.readWrite == 10 || item.readWrite == 30) && item.userFlag == 10
          );
          this.deviceReadParamList.splice(0, 0);
        }
        if (flag === 2) {
          // readWrite 20：可写 30：可读可写 并且 userEdit 10：用户可设置
          this.deviceWriteParamList[index] = this.deviceParamsList.filter(
            (item) => (item.readWrite == 20 || item.readWrite == 30) && item.userEdit == 10
          );
          this.deviceWriteParamList.splice(0, 0);
        }
      });
    },
    changeConditionAttr(id,index) {
      this.conditionValueList[index] = [];
      var dictItem=this.deviceParamsList.filter(
        (item) => item.id == id
      )[0];
      if (dictItem['fanwei']!=null&&dictItem['fanwei'].indexOf(";")>0) {
        var fanwei=dictItem['fanwei'].split(";");
        var items=[];
        for (var i=0; i<fanwei.length; i++) {
          var item={};
          item.label=fanwei[i].split(":")[1];
          item.value=fanwei[i].split(":")[0];
          items.push(item);
        }
        this.conditionValueList[index]=items;
      }
    },
    changeActionAttr(id,index) {
      this.actionValueList[index] = [];
      var dictItem=this.deviceParamsList.filter(
        (item) => item.id == id
      )[0];
      if (dictItem['fanwei']!=null&&dictItem['fanwei'].indexOf(";")>0) {
        var fanwei=dictItem['fanwei'].split(";");
        var items=[];
        for (var i=0; i<fanwei.length; i++) {
          var item={};
          item.label=fanwei[i].split(":")[1];
          item.value=fanwei[i].split(":")[0];
          items.push(item);
        }
        this.actionValueList[index]=items;
      }
    },
    changeReadConditionDevice(e, index) {
      this.deviceReadParamList[index] = [];
      this.getDeviceParams(e, index, 1);
    },
    changeWriteConditionDevice(e, index) {
      this.deviceWriteParamList[index] = [];
      this.getDeviceParams(e, index, 2);
    },
    addCondition() {
      const key = "cond_" + new Date().getTime();
      this.conditions.push({
        deviceId: "",
        attr: "",
        cmp: "",
        value: "",
        key,
      });
      this.setFormValue(key + "_deviceId", "");
      this.setFormValue(key + "_attr", "");
      this.setFormValue(key + "_cmp", "");
      this.setFormValue(key + "_value", "");
    },
    addAction() {
      const key = "act_" + new Date().getTime();
      this.actions.push({
        deviceId: "",
        attr: "",
        value: "",
        key,
      });
      this.setFormValue(key + "_deviceId", "");
      this.setFormValue(key + "_attr", "");
      this.setFormValue(key + "_value", "");
    },
    // 删除 当前行 设定条件
    deleteCondition(index, item) {
      this.conditions.splice(index, 1);
      const deviceName = item.key + "_deviceId";
      const attrName = item.key + "_attr";
      const compareName = item.key + "_cmp";
      const valueName = item.key + "_value";
      this.deleteFormValue(deviceName);
      this.deleteFormValue(attrName);
      this.deleteFormValue(compareName);
      this.deleteFormValue(valueName);
    },
    deleteAction(index, item) {
      this.actions.splice(index, 1);
      const key = item.key;
      const deviceName = key + "_deviceId";
      const attrName = key + "_attr";
      const valueName = key + "_value";
      this.deleteFormValue(deviceName);
      this.deleteFormValue(attrName);
      this.deleteFormValue(valueName);
    },
    // 动态设置 form 的某个属性和值
    setFormValue(keyName, value) {
      this.$set(this.form, keyName, value);
    },
    // 动态删除 form 的某个属性和值
    deleteFormValue(keyName) {
      this.$delete(this.form, keyName);
    },
    // 只读参数格式化中文
    fmtConditionAttrNickName(id) {
      for (let i = 0; i < this.deviceReadParamList.length; i++) {
        const item = this.deviceReadParamList[i] || [];
        for (let j = 0; j < item.length; j++) {
          if (item[j].id === id) {
            return item[j].name;
          }
        }
      }
    },
    // 可读写参数格式化中文名字
    fmtActionsAttrNickName(id) {
      for (let i = 0; i < this.deviceWriteParamList.length; i++) {
        const item = this.deviceWriteParamList[i] || [];
        for (let j = 0; j < item.length; j++) {
          if (item[j].id === id) {
            return item[j].name;
          }
        }
      }
    },
    // 格式化 触发动作数据
    fmtActions() {
      let obj = {};
      const formResult = this.form;
      const arr = Object.keys(formResult);
      arr.forEach((key) => {
        const value = formResult[key];
        if (key.indexOf("act_") > -1) {
          obj[key] = value;
        }
      });
      let items = [];
      for (let i = 0; i < this.actions.length; i++) {
        const item = this.actions[i];
        const device = obj[item.key + "_deviceId"];
        const attr = obj[item.key + "_attr"];
        const value = obj[item.key + "_value"];
        items.push({
          deviceId: device,
          id: attr,
          attr: this.fmtActionsAttrNickName(attr),
          value: value,
        });
      }
      return items;
    },
    // 格式化 触发条件数据
    fmtConditions() {
      let obj = {};
      const formResult = this.form;
      const arr = Object.keys(formResult);
      arr.forEach((key) => {
        const value = formResult[key];
        if (key.indexOf("cond_") > -1) {
          obj[key] = value;
        }
      });
      let items = [];
      for (let i = 0; i < this.conditions.length; i++) {
        const item = this.conditions[i];
        const device = obj[item.key + "_deviceId"];
        const attr = obj[item.key + "_attr"];
        const cmp = obj[item.key + "_cmp"];
        const value = obj[item.key + "_value"];
        items.push({
          deviceId: device,
          id: attr,
          attr: this.fmtConditionAttrNickName(attr),
          cmp: cmp,
          value: value,
        });
      }
      return items;
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const conditions = this.fmtConditions();
          const actions = this.fmtActions();
          if (this.form.id) {
            this.submitEdit(conditions, actions)
          } else {
            this.submitAdd(conditions, actions)
          }
        } else {
          this.$message.warning("场景条件必须填写");
          return false;
        }
      });
    },
    submitAdd(conditions, actions) {
      if (this.form.ruleType==20) {
        conditions=null;
      }
      this.request.addRule({
        actions,
        conditions,
        ruleType: this.form.ruleType,
        trigerTime: this.form.trigerTime,
        weekDays: this.form.weekDays,
        name: this.form.name,
        project: this.projectCurrentRowData.projectCode,
      }).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.reset();
          this.$refs.detail.getData();
        }
      });
    },
    submitEdit(conditions, actions) {
      if (this.form.ruleType==20) {
        conditions=null;
      }
      this.request.editRule({
        actions,
        conditions,
        ruleType: this.form.ruleType,
        trigerTime: this.form.trigerTime,
        weekDays: this.form.weekDays,
        name: this.form.name,
        id: this.form.id,
        project: this.projectCurrentRowData.projectCode,
      }).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.reset();
          this.$refs.detail.getData();
        }
      });
    },
    reset() {
      const key = new Date().getTime();
      this.form = {};
      this.setFormValue("name", "");
      this.setFormValue("cond_" + key + "_deviceId", "");
      this.setFormValue("cond_" + key + "_attr", "");
      this.setFormValue("cond_" + key + "_cmp", "");
      this.setFormValue("cond_" + key + "_value", "");
      this.setFormValue("act_" + key + "_deviceId", "");
      this.setFormValue("act_" + key + "_attr", "");
      this.setFormValue("act_" + key + "_value", "");
      this.conditions = [
        {
          deviceId: "",
          attr: "",
          cmp: "",
          value: "",
          key: "cond_" + key,
        },
      ];
      this.actions = [
        {
          deviceId: "",
          attr: "",
          value: "",
          key: "act_" + key,
        },
      ];
      this.deviceConditionList = [];
      this.$refs.form.resetFields();
    },
    // 编辑详情
    getDetailInfo(item) {
      this.request.infoRule({ id: item.id }).then((res) => {
        if (res.code === 0 && res.data && res.data.id) {
          this.form.id = res.data.id;
          this.form.ruleType = res.data.ruleType;
          this.form.name = res.data.name;
          this.form.trigerTime = res.data.trigerTime;
          this.form.weekDays = res.data.weekDays;
          const _conditions = JSON.parse(JSON.stringify(res.data.conditions||[]));
          for (let i = 0; i < _conditions.length; i++) {
            const key = new Date().getTime()+Math.round(Math.random() * 10000);
            _conditions[i]["key"] = "cond_" + key;
            const deviceId = _conditions[i].deviceId;
            const attr = _conditions[i].id;
            const cmp = _conditions[i].cmp;
            const value = _conditions[i].value;
            this.setFormValue("cond_" + key + "_deviceId", deviceId);
            this.setFormValue("cond_" + key + "_attr", attr*1);
            this.setFormValue("cond_" + key + "_cmp", cmp);
            this.setFormValue("cond_" + key + "_value", value);
            this.changeReadConditionDevice(deviceId, i);
          }
          const _actions = JSON.parse(JSON.stringify(res.data.actions||[]));
          for (let i = 0; i < _actions.length; i++) {
            const key = new Date().getTime()+Math.round(Math.random() * 10000);
            _actions[i]["key"] = "act_" + key;
            const deviceId = _actions[i].deviceId;
            const attr = _actions[i].id;
            const value = _actions[i].value;
            this.setFormValue("act_" + key + "_deviceId", deviceId);
            this.setFormValue("act_" + key + "_attr", attr*1);
            this.setFormValue("act_" + key + "_value", value);
            this.changeWriteConditionDevice(deviceId, i);
          }
          this.conditions = _conditions;
          this.actions = _actions;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.fixed-project {
  position: fixed; 
  top: 70px; 
  left: 420px;
  height: 32px;
  line-height: 32px;
  border-radius: 5px;
  color: black;
  text-align: left;
  font-size: small;
  z-index: 999;
}
.scene-view {
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  .scene-header {
    height: 60px;
    line-height: 60px;
    font-family: "microsoft yahei ui","microsoft yahei";
    font-size: 16px;
    color: #424e66;
    padding-left: 24px;
    border-bottom: 1px solid #d8d8d8;
    box-sizing: border-box;
  }

  .scene-container {
    height: calc(100% - 60px);
    padding: 12px;
    padding-top: 0;
    box-sizing: border-box;
    overflow-y: auto;
    .exp-title {
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 16px;
      color: #424e66;
      margin-bottom: 18px;
      margin-top: 18px;
    }

    .container {
      margin: 18px 0;
      .el-form-item {
        margin-bottom: 0;
      }
    }

    .box-label {
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 12px;
      color: #666666;
      margin-bottom: 8px;
    }

    .box-container {
      background: #f5f5f7;
      box-sizing: border-box;
      padding-top: 8px;
      padding-left: 8px;
      padding-bottom: 8px;
      height: 134px;
      .box-scroll {
        height: 90px;
        overflow-y: auto;
        padding-right: 8px;
        box-sizing: border-box;
      }
      .box-label-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4px;
        .blankDiv {
          width: 50px;
          color: #999999;
          font-size: 12px;
          text-align: center;
        }
        .group-title {
          color: #333333;
          font-size: 14px;
        }
        .label {
          width: 33%;
          font-family: "microsoft yahei ui","microsoft yahei";
          font-size: 12px;
          color: #999999;
          margin-bottom: 12px;
          text-align: center;
        }
        .value {
          width: 33%;
          font-family: "microsoft yahei ui","microsoft yahei";
          font-size: 12px;
          color: #333333;
          text-align: center;
          line-height: 28px;
        }
        .longlabel {
          width: 34%;
          text-align: left;
        }
        .longvalue {
          width: 34%;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .add-btn {
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 12px;
      text-align: left;
      color: #999999;
      cursor: pointer;
      line-height: 30px;
      width: 80px;
      text-align: center;
      &:hover {
        color: #3456ff;
      }
    }

    .el-icon-delete {
      cursor: pointer;
      &:hover {
        color: red;
      }
    }

    .submit-btn {
      display: flex;
      align-items: center;
      .submit-btn-item {
        width: 134px;
        height: 32px;
        border-radius: 2px;
        opacity: 1;
        background: #3456ff;
        cursor: pointer;
        text-align: center;
        line-height: 32px;
        &:nth-child(1) {
          color: #fff;
        }
        &:nth-child(2) {
          background-color: #fff;
        }
      }
    }
  }
}
</style>
